import * as types from './_actionTypes';

export const fetchSmeRequestsRequest = () => ({
  type: types.FETCH_SME_REQUESTS_REQUEST
});

export const fetchSmeRequestsSuccess = (requests) => ({
  type: types.FETCH_SME_REQUESTS_SUCCESS,
  payload: requests
});

export const fetchSmeRequestsFailure = (error) => ({
  type: types.FETCH_SME_REQUESTS_FAILURE,
  payload: error
});

export const approveSmeRequest = (smeId) => ({
  type: types.APPROVE_SME_REQUEST,
  payload: smeId
});

export const approveSmeSuccess = (smeId) => ({
  type: types.APPROVE_SME_SUCCESS,
  payload: smeId
});

export const approveSmeFailure = (error) => ({
  type: types.APPROVE_SME_FAILURE,
  payload: error
});

export const rejectSmeRequest = (smeId) => ({
  type: types.REJECT_SME_REQUEST,
  payload: smeId
});

export const rejectSmeSuccess = (smeId) => ({
  type: types.REJECT_SME_SUCCESS,
  payload: smeId
});

export const rejectSmeFailure = (error) => ({
  type: types.REJECT_SME_FAILURE,
  payload: error
});

export const fetchContentRequestsRequest = () => ({
  type: types.FETCH_CONTENT_REQUESTS_REQUEST
});

export const fetchContentRequestsSuccess = (requests) => ({
  type: types.FETCH_CONTENT_REQUESTS_SUCCESS,
  payload: requests
});

export const fetchContentRequestsFailure = (error) => ({
  type: types.FETCH_CONTENT_REQUESTS_FAILURE,
  payload: error
});

export const approveContentRequest = (contentId) => ({
  type: types.APPROVE_CONTENT_REQUEST,
  payload: contentId
});

export const approveContentSuccess = (contentId) => ({
  type: types.APPROVE_CONTENT_SUCCESS,
  payload: contentId
});

export const approveContentFailure = (error) => ({
  type: types.APPROVE_CONTENT_FAILURE,
  payload: error
});